/* eslint-disable  */

import { AutocompleteGeneric } from './ac-generic';

const getRandomString = () =>
  Math.random()
    .toString(36)
    .substr(2, 9);

export class AutocompleteBaidu extends AutocompleteGeneric {
  getLibrary() {
    // No special library is required ('ajax-like' call)
    // > Baidu use a JSONP method, and need a callback to return response
    // > JSONP callback must be kept in the global window variable
    window.poolCallback = {};
    // to avoid multiplying global variables (1 for each input-search)
    // we create only 1 pool that will hold all the callbacks
    return Promise.resolve();
  }

  // from an 'input' val
  // returns a list a 'suggestions', through the 'resolvePromise' callback
  searchSuggestions(input, resolvePromise) {
    // create 'random' name for the callback function
    const cbName = '_' + getRandomString();
    // build unique callback that will resolve the promise with results /!\ baidu doesn't return an array directly)
    window.poolCallback[cbName] = baiduResult =>
      resolvePromise(
        baiduResult.result.map(sugg =>
          Object.assign(sugg, { description: sugg.name })
        ) || []
      );
    // call the Baidu API that will execute the callback once loaded
    $.getScript(
      `https://api.map.baidu.com/place/v2/suggestion?q=迪卡侬+${input}&region=全国&output=json&ak=GqAzO5k3Y81bB5rlkA33XDve&callback=poolCallback.${cbName}`,
      // callback after script loaded : keep memory clean by removing the previously created callback (after 1 sec, to be sure)
      () => setTimeout(() => delete window.poolCallback[cbName], 1000)
    );
  }

  // from a 'suggestion'
  // returns a detailed 'position' through the 'resolvePromise' callback
  searchPosition(suggestion, resolvePromise) {
    resolvePromise({
      name: suggestion.name,
      latitude: suggestion.location.lat,
      longitude: suggestion.location.lng,
    });
  }
}



// WEBPACK FOOTER //
// ./src/commons/component/autocomplete/ac-baidu.js